export default __webpack_public_path__ + "static/card_img-1-0dd333c711a2879c0d516001f025bd8a.jpg";